// components/MyPage/components/NotificationSettings.js
import React from "react";
import { Save } from "lucide-react";
import { 
  ContentHeader, 
  ContentTitle, 
  Form, 
  ToggleOption, 
  ToggleText, 
  ToggleDescription, 
  ToggleSwitch,
  SaveButton 
} from "./css";

const NotificationSettings = ({ formData, handleChange, handleSubmit }) => {
  return (
    <>
      <ContentHeader>
        <ContentTitle>알림 설정</ContentTitle>
      </ContentHeader>
      <Form onSubmit={handleSubmit}>
        <ToggleOption>
          <div>
            <ToggleText>이메일 알림</ToggleText>
            <ToggleDescription>이메일로 중요 알림을 받습니다</ToggleDescription>
          </div>
          <ToggleSwitch>
            <input
              type="checkbox"
              name="emailNotifications"
              checked={formData.emailNotifications}
              onChange={handleChange}
            />
            <span className="slider"></span>
          </ToggleSwitch>
        </ToggleOption>
        <ToggleOption>
          <div>
            <ToggleText>작업 마감일 알림</ToggleText>
            <ToggleDescription>작업 마감일 전에 알림을 받습니다</ToggleDescription>
          </div>
          <ToggleSwitch>
            <input
              type="checkbox"
              name="taskReminders"
              checked={formData.taskReminders}
              onChange={handleChange}
            />
            <span className="slider"></span>
          </ToggleSwitch>
        </ToggleOption>
        <SaveButton type="submit">
          <Save size={16} />
          저장
        </SaveButton>
      </Form>
    </>
  );
};

export default NotificationSettings;